import * as DialogPrimitive from '@radix-ui/react-dialog'
import React from 'react'
import { cn } from '#app/utils/misc.tsx'
import {
	Dialog,
	DialogClose,
	DialogHeader,
	DialogPortal,
	DialogTrigger,
} from '../ui/dialog'
import { Icon } from '../ui/icon'

const PublicDialog = Dialog

const PublicDialogTrigger = DialogTrigger

const PublicDialogPortal = DialogPortal

const PublicDialogClose = DialogClose

const PublicDialogOverlay = React.forwardRef<
	React.ElementRef<typeof DialogPrimitive.Overlay>,
	React.ComponentPropsWithoutRef<typeof DialogPrimitive.Overlay>
>(({ className, ...props }, ref) => (
	<DialogPrimitive.Overlay
		ref={ref}
		className={cn(
			'fixed inset-0 z-50 bg-white/10 backdrop-blur-sm data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0',
			className,
		)}
		{...props}
	/>
))
PublicDialogOverlay.displayName = DialogPrimitive.Overlay.displayName

const PublicDialogHeader = DialogHeader

const PublicDialogTitle = React.forwardRef<
	React.ElementRef<typeof DialogPrimitive.Title>,
	React.ComponentPropsWithoutRef<typeof DialogPrimitive.Title>
>(({ className, ...props }, ref) => (
	<DialogPrimitive.Title
		ref={ref}
		className={cn(
			'text-base font-medium leading-none tracking-[0.2em] text-brand-dusk',
			className,
		)}
		{...props}
	/>
))
PublicDialogTitle.displayName = DialogPrimitive.Title.displayName

const PublicDialogContent = React.forwardRef<
	React.ElementRef<typeof DialogPrimitive.Content>,
	React.ComponentPropsWithoutRef<typeof DialogPrimitive.Content>
>(({ className, children, ...props }, ref) => (
	<PublicDialogPortal>
		<PublicDialogOverlay />
		<DialogPrimitive.Content
			ref={ref}
			className={cn(
				'fixed left-[50%] top-[50%] z-50 grid max-h-[95vh] w-full max-w-lg translate-x-[-50%] translate-y-[-50%] gap-sm overflow-y-auto border bg-background p-md shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] md:p-xl xl:p-xxl 2xl:p-xxxl',
				className,
			)}
			{...props}
		>
			{children}
			<DialogPrimitive.Close className="absolute right-4 top-4 rounded opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-accent data-[state=open]:text-muted-foreground">
				<Icon name="lucide-x" className="h-4 w-4" />
				<span className="sr-only">Close</span>
			</DialogPrimitive.Close>
		</DialogPrimitive.Content>
	</PublicDialogPortal>
))
PublicDialogContent.displayName = DialogPrimitive.Content.displayName

export {
	PublicDialog,
	PublicDialogTrigger,
	PublicDialogPortal,
	PublicDialogClose,
	PublicDialogOverlay,
	PublicDialogHeader,
	PublicDialogTitle,
	PublicDialogContent,
}
